module.exports = __webpack_public_path__ + "static/smi1Mini-7072b7a39db0078ccd2ecabc3710db0e.png";